var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMintedBar = function SvgMintedBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 95h50.9c3.9 0 7-3.1 7-7V12c0-3.9-3.1-7-7-7H24.5c-3.9 0-7 3.1-7 7v76c0 3.8 3.2 7 7 7m1-82h48.9v74H25.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7 56.2H36.3c-2.2 0-4 1.8-4 4s1.8 4 4 4h27.3c2.2 0 4-1.8 4-4s-1.7-4-3.9-4M63.7 69.9H36.3c-2.2 0-4 1.8-4 4s1.8 4 4 4h27.3c2.2 0 4-1.8 4-4s-1.7-4-3.9-4M50 49.4c7.9 0 14.2-6.4 14.2-14.2S57.9 21 50 21s-14.2 6.4-14.2 14.2S42.1 49.4 50 49.4M50 29c3.4 0 6.2 2.8 6.2 6.2s-2.8 6.2-6.2 6.2-6.2-2.8-6.2-6.2S46.6 29 50 29"
  })));
};
export default SvgMintedBar;